import { connect } from 'react-redux';
import styled from 'styled-components';

import { getActiveFile } from './data/reducer';

const Container = styled.div`
  background: transparent;
  display: flex;
  height: 100%;
  justify-content: center;
`;

const Label = styled.div`
  margin-bottom: 0;
  font-weight: 600;
  text-align: center;
`;

const UnsupportedFileInstructions = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LabelText = styled.span`
  color: #444;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  margin-bottom: 0.5em;
  display: block;
`;

const FileName = styled.h2`
  font-weight: 700;
  font-size: 1.6rem;
`;

const connector = connect((state) => ({
  activeFile: getActiveFile(state),
}));

const UnsupportedFileScreen = ({ activeFile }) => (
  <Container>
    <UnsupportedFileInstructions>
      <Label>
        <LabelText>Unable to display</LabelText>
        <FileName>{activeFile?.filename ?? 'unknown'}</FileName>
      </Label>
    </UnsupportedFileInstructions>
  </Container>
);

export default connector(UnsupportedFileScreen);
